module.exports = __webpack_public_path__ + "static/img/avatar_woman.78eb9e1b.jpg";